import React from "react";
import Slide1 from "../../images/home/pic1.jpg";
import Slide2 from "../../images/home/pic4.jpg";
import Slide3 from "../../images/home/pic3.jpg";
import Fadeup from "../fadeup/Fadeup";

const slides = [ Slide3, Slide1, Slide2,];

function HomeBanner() {
  return (
    <section className="mt-5">
      <div className="sec_pd">
      <Fadeup delay={0.3}>
      <h3 className="text-center  mx-3  pb-2 text-black fs_40">
          Explore Our Art Gallery<br /> Artistic Wanderings
        </h3>
        </Fadeup>
        <Fadeup delay={0.2}>
        <p className="text-center sub_para   mb-4 mx-3  border-bottom pb-2 text-black">Step into a world of creativity and imagination as you explore our art gallery,<br />  Artistic Wanderings. Each piece tells a unique story, capturing emotions, perspectives, and the essence of artistic expression. From mesmerizing paintings to intricate sculptures,<br />  our collection showcases a diverse range of styles and techniques. Whether you're an art enthusiast or a casual admirer, <br /> let yourself be inspired by the beauty and depth of each masterpiece. Discover, appreciate, and lose yourself in the world of art.</p>
        </Fadeup>
        
      <div 
        id="carouselExampleControls" 
        className="carousel slide bg-white floral-border rounded mt-5" 
        data-bs-ride="carousel" 
        data-bs-interval="2000" 
      >
        <div className="carousel-inner rounded ">
          {slides.map((slide, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
              <img src={slide} width={800} height={700} className="d-block w-100  slide_image" alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
        {/* <div className="position-absolute bottom-0 start-50 translate-middle-x mb-5">
          <button className="btn btn-outline-warning  bg-warning fw-bold text-white border-2 btn-lg">
            Discover Auction
          </button>
        </div> */}




      </div>
      </div>
    </section>
  );
}

export default HomeBanner;
